import { render } from "./DevUtils.vue?vue&type=template&id=5a8ee168"
import script from "./DevUtils.vue?vue&type=script&lang=js"
export * from "./DevUtils.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__